export const TEXTS = {
  ACCEPTANCE_ADVANCED_MODAL_TITLE: 'Выбор типа оплаты',
  ACCEPTANCE_ADVANCED_MODAL_DESCRIPTION_HEADER: 'Текущий тип оплаты — СберБизнес Онлайн.',
  ACCEPTANCE_ADVANCED_MODAL_DESCRIPTION:
    'Для создания и оплаты новых адресов надо подписать согласие на списание со счёта СберБизнес Онлайн или выбрать другой тип оплаты.',
  ACCEPTANCE_ADVANCED_MODAL_PRIMARY_BUTTON_TEXT: 'Перейти в СберБизнес Онлайн',
  ACCEPTANCE_ADVANCED_MODAL_SECONDARY_BUTTON_TEXT: 'Выбрать другой тип оплаты',
  ACCEPTANCE_ADVANCED_MODAL_NOTIFICATION_ERROR_MESSAGE:
    'Процесс подписания согласия на списание средств недоступен. Пожалуйста, попробуйте позже',
};
